// src/utils/videoVerificatie.js
//
// Tweede slot op de video-analyse: na een code per e-mail geeft de backend een ondertekend token
// (8 uur). Dat staat in localStorage (geldt in alle tabbladen van deze browser, weg bij uitloggen) en
// gaat als header X-Video-Verificatie mee met elke aanroep van de video-analyse-API. Het token hoort bij
// het account: een ander account in dezelfde browser kan het niet gebruiken.
const SLEUTEL = 'videoVerificatie';
export const VERIFICATIE_VERLOPEN_EVENT = 'video-verificatie-verlopen';

function lees() {
  try {
    return localStorage.getItem(SLEUTEL);
  } catch {
    return null;
  }
}

// Vervaltijd (ms) uit het token: <id>.<verloopt>.<handtekening>
export function verificatieTot(token = lees()) {
  if (!token) return null;
  const tot = Number(token.split('.')[1]);
  return Number.isFinite(tot) ? tot : null;
}

export function geldigToken() {
  const token = lees();
  const tot = verificatieTot(token);
  return token && tot && tot > Date.now() + 5000 ? token : null;
}

export function bewaarToken(token) {
  try {
    localStorage.setItem(SLEUTEL, token);
  } catch {
    // Zonder localStorage (privémodus met blokkade) vraagt elke pagina opnieuw een code.
  }
}

export function wisToken() {
  try {
    localStorage.removeItem(SLEUTEL);
  } catch {
    // niets
  }
}

export function videoHeaders(jwt) {
  const headers = { Authorization: `Bearer ${jwt}` };
  const token = geldigToken();
  if (token) headers['X-Video-Verificatie'] = token;
  return headers;
}

// 403 met code VIDEO_VERIFICATIE_VEREIST van de backend: token verlopen of ongeldig.
export function isVerificatieFout(error) {
  return (
    error?.response?.status === 403 &&
    error?.response?.data?.error?.details?.code === 'VIDEO_VERIFICATIE_VEREIST'
  );
}

// Laat de VideoVerificatie-poort het codescherm tonen.
export function meldVerificatieVerlopen() {
  wisToken();
  window.dispatchEvent(new Event(VERIFICATIE_VERLOPEN_EVENT));
}
